<template>
    <v-layout row wrap xs12 sm12 md12 lg12 ml-2 mr-2>

        <!--上一周 下一周 UI-->
        <v-flex   class="xs12 sm12 md9 ml-0 "> <!--row wrap justify-space-around style="height: 50px"-->
            <!--<v-flex xs12 sm12 md12 text-center row&#45;&#45;dense>-->
                <!--[{{zoneName}}]-->
            <!--</v-flex>-->

            <v-flex  xs12 sm12 md12 >
               <span class="fontMiddle">[{{zoneName}}] 今天日期: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{this.$UtilityJs.AD2ROC_Date(new Date().toISOString())}}</span> </span>
                <!--<span class="fontMiddle"> 西元: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'> {{this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date').replace(new RegExp("-","gm"),"/")}}</span> </span>-->
            </v-flex>

            <v-flex  xs12 sm12 md12 fontMiddle :style="{textAlign:$vuetify.breakpoint.smAndDown?'center':'left'}">
                <span class="fontMiddle"><span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{startRange}}</span> </span>
                <span class="fontMiddle">至<span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{endRange}} </span> </span>
                <v-btn  @click="lastWeek" middle class="pl-1 pr-1 mr-2 regFRBtn">
                    上一週
                </v-btn>
                <v-btn @click="nextWeek" middle class="pr-1 pl-1 regFRBtn">
                    下一週
                </v-btn>
            </v-flex>

            <!--<v-flex  xs12 sm12 md12 >-->
                <!--<span class="fontMiddle">查詢期間: <span style="color: hotpink">{{startRange}}</span> </span>-->
                <!--<span class="fontMiddle"> 至 <span style="color: hotpink"> {{endRange}}</span> </span>-->
            <!--</v-flex>-->


            <v-flex  class="xs12 sm12 md12">

                <!--{{divName}} -->
                <div class="clinicATitle">看診時間表(上午)</div>

                <clinic-table   :clinic-data="clinicData1" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>
                <br/>


                <!--{{divName}} -->
                <div class="clinicATitle">看診時間表(下午)</div>

                <clinic-table  :clinic-data="clinicData2" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>

                <br/>

                <!--{{divName}} -->
                <div class="clinicATitle">看診時間表(晚上)</div>

                <clinic-table   :clinic-data="clinicData3" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>

                <br/>


            </v-flex>

        </v-flex>

        <v-flex :class="['xs12 sm12 md3 mt-1',$vuetify.breakpoint.smAndDown?'pl-1':'pl-7 pr-5']">
            <p v-html="regNote"></p>

        </v-flex>



    </v-layout>
</template>

<script>
    import ClinicTable from './ClinicTable'
    export default {
        name: "ClinicA",
        components:{ClinicTable},
        data() {
            return {
                zoneName:'',
                startRange:'',
                endRange:'',
                clinicData: [],
                loading:false,
                loadingText:'查詢中...',
                clinicData1:[],
                clinicData2:[],
                clinicData3:[],
                clinicHeaders:[
                    {
                        text: '診間名稱',
                        // align: 'left',
                        value: 'clinicName',
                        class:'px-1'
                    },
                    {
                        text: '星期一',
                        // align: 'left',
                        value: 'viewItemName1',
                        class:'px-1'
                    },
                    {
                        text: '星期二',
                        // align: 'left',
                        value: 'viewItemName2',
                        class:'px-1'
                    },
                    {
                        text: '星期三',
                        // align: 'left',
                        value: 'viewItemName3',
                        class:'px-1'
                    },
                    {
                        text: '星期四',
                        // align: 'left',
                        value: 'viewItemName4',
                        class:'px-1'
                    },
                    {
                        text: '星期五',
                        // align: 'left',
                        value: 'viewItemName5',
                        class:'px-1'
                    },
                    {
                        text: '星期六',
                        // align: 'left',
                        value: 'viewItemName6',
                        class:'px-1'
                    },
                    {
                        text: '星期日',
                        // align: 'left',
                        value: 'viewItemName7',
                        class:'px-1'
                    },
                ],
                startDate:'',
                endDate:'',
                regNote:'',
                divName:'',
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
            this.startDate = today;
            this.startDate = this.getStartDate();
            this.endDate = this.getEndDate();
            this.axios_getClinicData();
            let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
            let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
            this.axios_getRegNote(divCode+','+empNo);
            this.axios_getZoneName();
            // if(this.$route.query.divName==undefined){
            //     this.axios_getDivNoList(divCode);
            // }else {
            //     this.divName = this.$route.query.divName;
            // }
        },
        watch: {
            '$route.params': function () {
                this.axios_getClinicData();
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
                this.axios_getRegNote(divCode+','+empNo);
                this.axios_getZoneName();
            },
            // '$route.query.zone': function () { //110/09/17 偵測如果zone改變 班表 資料要重抓 by IvyLin
            //     this.axios_getClinicData();
            //     let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
            //     let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
            //     this.axios_getRegNote(divCode+','+empNo);
            // },
        },
        methods:{
            setHeader(data){
                return data.filter((i) => {
                    return i.clinicNo== 9999;
                })
            },
            setNotHeader(data){
                return data.filter((i) => {
                    return i.clinicNo!== 9999;
                })
            },
            lastWeek(){
                this.startDate = this.getLastWeek(this.startDate);
                this.endDate= this.getEndDate();
                this.axios_getClinicData();
            },
            nextWeek(){
                this.startDate = this.getNextWeek(this.startDate);
                this.endDate = this.getEndDate();
                this.axios_getClinicData();
            },
            getStartDate(){ //取得當下日期 當周 星期一
                let sDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = sDate.substring(0,4);
                let m = sDate.substring(4,6);
                let d = sDate.substring(6,8)
                let startDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);
                // let startDate = new Date(this.startDate+" 00:00:00");

                if(startDate.getDay() == 0)
                {
                    startDate.setDate(startDate.getDate() - 6);
                }
                else
                {
                    startDate.setDate(startDate.getDate() - (startDate.getDay()-1));
                }

                return this.$UtilityJs.AD2ROC_DateTime(startDate.toISOString(),'date');

            },
            getEndDate(){ //取得當下日期 當周 星期日
                // let endDate = new Date(this.startDate+" 00:00:00");
                let eDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);
                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (7-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getNextWeek(start){ //取得下一周
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);
                // let endDate = new Date(start+" 00:00:00");
                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getLastWeek(start){ //取得上一周
                // let endDate = new Date(start+" 00:00:00");
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);
                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() - (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            setHeaders(data){
                this.clinicHeaders = [];
                this.clinicHeaders.push(
                    {
                        text: data[0].clinicName,
                        // align: 'left',
                        value: 'clinicName',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName1+'<br/>'+data[0].clinicTable[0].viewItemUrl1,
                        // align: 'left',
                        value: 'viewItemName1',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName2+'<br/>'+data[0].clinicTable[0].viewItemUrl2,
                        // align: 'left',
                        value: 'viewItemName2',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName3+'<br/>'+data[0].clinicTable[0].viewItemUrl3,
                        // align: 'left',
                        value: 'viewItemName3',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName4+'<br/>'+data[0].clinicTable[0].viewItemUrl4,
                        // align: 'left',
                        value: 'viewItemName4',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName5+'<br/>'+data[0].clinicTable[0].viewItemUrl5,
                        // align: 'left',
                        value: 'viewItemName5',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName6+'<br/>'+data[0].clinicTable[0].viewItemUrl6,
                        // align: 'left',
                        value: 'viewItemName6',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName7+'<br/>'+data[0].clinicTable[0].viewItemUrl7,
                        // align: 'left',
                        value: 'viewItemName7',
                        class:'px-1'
                    },
                )
            },

            filterClinicData(arrayList,apn){
                let data = [];
                arrayList.filter(function (item,i) {
                    item.clinicTable.filter(function (subItem,index,array) {

                        if(index==apn){
                            data.push(array[index]);
                            data[i].clinicName = item.clinicName;
                            data[i].clinicNo = item.clinicNo;
                        }
                    })

                })
                return data;
            },
            axios_getClinicData (){ //門診清單

                this.loading = true;
                let url = '';
                let start = this.startDate.replace(new RegExp("-","gm"),"");
                let end =   this.endDate.replace(new RegExp("-","gm"),"");
                start = parseInt(start.substring(0,4))-1911+""+start.substring(4,8)
                end = parseInt(end.substring(0,4))-1911+""+end.substring(4,8)

                this.startRange = this.$UtilityJs.AD2ROC_Date(this.startDate);
                this.endRange = this.$UtilityJs.AD2ROC_Date(this.endDate);
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'ALL':this.$route.query.empNo;

                url = this.$store.state.AppSetting.backSrvUrl + "clinicparam/clinictable/"+zone+"/"+start+"/"+end+"/"+divCode+"/"+empNo;
                // alert(url)


                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicData = response.data.resultSet;
                        let header = this.setHeader(this.clinicData);
                        this.setHeaders(header);
                        this.loading = false;
                        let noHeaderArray =  this.setNotHeader(this.clinicData);
                        this.clinicData1 = this.filterClinicData(noHeaderArray,0);
                        this.clinicData2 = this.filterClinicData(noHeaderArray,1);
                        this.clinicData3 = this.filterClinicData(noHeaderArray,2);

                    }else{
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }
                }).catch(error =>  {

                    try {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                        console.log(error.response.data.status);

                    } catch(err) {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }

                });
            },
            axios_getRegNote (codeNo){ //掛號說明
                let url = '';
                this.regNote = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/CLINIC/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.regNote = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regNote = '';
                    } catch(err) {
                        this.regNote = '';
                    }
                });
            },
            axios_getDivNoList(divNo){ //取得科別清單 如果path 有傳入 divCode 則抓科別名稱顯示在畫面上
                this.divName = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/webregdiv/"+zone;

                this.$http.get(url).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        let data = response.data.resultSet;
                        for(let i in data){
                            if(data[i].divNo==divNo){
                                this.divName = data[i].divName;
                            }
                        }
                    }

                }).catch(error =>{
                    this.divName = '';
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
        }
    }
</script>

<style scoped>



</style>